<script lang="ts">
	import { Rive } from '@rive-app/canvas';
	import { onMount } from 'svelte';

	let canvas: HTMLCanvasElement;

	const triggers: any = {
		spyglass: {
			in: null,
			out: null
		},
		verification: {
			in: null,
			out: null
		},
		typewriter: {
			in: null,
			out: null
		}
	}; //triggers for each animation
	const resolution: number = 400; //resolution of canvas
	const filePath = `${import.meta.env.VITE_HOST || location.origin}/rive-files/loading.riv`; //path to rive file
	const playTime = 4000; //playtime for each animation in ms
	const delay = 100; //delay in between animation transitions
	const timeouts: { [key: string]: ReturnType<typeof setTimeout> } = {};

	function playLoop() {
		const triggersArray = Object.keys(triggers);

		//set timeout for each trigger
		triggersArray.forEach((key, index) => {
			timeouts[crypto.randomUUID()] = setTimeout(() => {
				triggers[key].in?.fire();
				timeouts[crypto.randomUUID()] = setTimeout(() => {
					triggers[key].out?.fire();
				}, playTime + delay);
			}, playTime * index + delay);

			//set timeout to retrigger this function
			timeouts[crypto.randomUUID()] = setTimeout(() => {
				playLoop();
			}, playTime * triggersArray.length + delay);
		});
	}

	function clearTimeouts() {
		Object.keys(timeouts).forEach((timeout) => {
			clearTimeout(timeouts[timeout]);
		});
	}


	onMount(() => {
		const rive = new Rive({
			src: filePath,
			canvas: canvas,
			autoplay: true,
			stateMachines: 'State Machine 1',
			onLoad: (_) => {
				const inputs = rive.stateMachineInputs('State Machine 1');

				triggers.spyglass.in = inputs.find((i) => i.name === 'Spyglass in');
				triggers.spyglass.out = inputs.find((i) => i.name === 'Spyglass out');
				triggers.verification.in = inputs.find(
					(i) => i.name === 'Verification in'
				);
				triggers.verification.out = inputs.find(
					(i) => i.name === 'Verification out'
				);
				triggers.typewriter.in = inputs.find((i) => i.name === 'Typewriter in');
				triggers.typewriter.out = inputs.find(
					(i) => i.name === 'Typewriter out'
				);

				playLoop();
			}
		});

		return () => {
			clearTimeouts();
			rive.cleanup();
		};
	});
</script>

<div class="canvas-container">
	<canvas width={resolution} height={resolution} bind:this={canvas} />
</div>

<style lang="scss">
	.canvas-container {
		height: 100%;
		width: 100%;
		display: flex;
		justify-content: center;

		canvas {
			height: 200px;
			width: 200px;
		}
	}
</style>
